// extracted by mini-css-extract-plugin
module.exports = {"search":"search-field_search__NqGYL","dark":"search-field_dark__l2dVT"};